export interface RetriableCareCompanionMessage {
	id: string;
	content: string;
}

export function getCareCompanionMessageId(
	content: string,
	retry: RetriableCareCompanionMessage | null,
	createMessageId: () => string,
): string {
	return retry?.content === content ? retry.id : createMessageId();
}
